import React from 'react'
import { useIntl } from 'react-intl'
import { Redirect, useLocation } from 'react-router-dom'
import { useAccess } from './AccessContext'
import { routeAllowed } from './accessPolicy'
import paths from '../routes/paths'

export default function AccessGate({ children }) {
  const { access, loading, failed, profileRequired, reload, logout } = useAccess()
  const location = useLocation()
  const { formatMessage: trans } = useIntl()

  if (!access && loading) {
    return <div className="p-4">{trans({ id: 'access_loading', defaultMessage: 'Loading access…' })}</div>
  }
  if (failed) {
    return (
      <div className="p-4">
        <h2>{trans({ id: 'access_verify_failed_title', defaultMessage: 'Access could not be verified' })}</h2>
        <p>{trans({ id: 'access_verify_failed_body', defaultMessage: 'Your session is still open, but modules stay hidden until permissions can be confirmed.' })}</p>
        <button type="button" className="btn btn-primary me-2" onClick={reload}>{trans({ id: 'access_retry', defaultMessage: 'Retry' })}</button>
        <button type="button" className="btn btn-outline-secondary" onClick={logout}>{trans({ id: 'access_sign_out', defaultMessage: 'Sign out' })}</button>
      </div>
    )
  }
  if (profileRequired) {
    return (
      <div className="p-4">
        <h2>{trans({ id: 'access_profile_required_title', defaultMessage: 'Your administrator must assign an access profile' })}</h2>
        <p>{trans({ id: 'access_profile_required_body', defaultMessage: 'Operation modules stay hidden until then.' })}</p>
        <button type="button" className="btn btn-primary me-2" onClick={reload}>{trans({ id: 'access_retry', defaultMessage: 'Retry' })}</button>
        <button type="button" className="btn btn-outline-secondary" onClick={logout}>{trans({ id: 'access_sign_out', defaultMessage: 'Sign out' })}</button>
      </div>
    )
  }
  if (access?.profileEnforced && !routeAllowed(location.pathname, access)) {
    return <Redirect to={{ pathname: paths.accessDenied, state: { from: location, reason: 'permission' } }} />
  }
  const noWarehouse = access?.profileEnforced && access.role !== 'admin' && !access.allWarehouses && !(access.warehouses || []).length
  return (
    <>
      {noWarehouse ? <div className="alert alert-warning m-3">{trans({ id: 'access_no_warehouse', defaultMessage: 'You have no authorized warehouses. Operations that depend on a warehouse stay blocked.' })}</div> : null}
      {children}
    </>
  )
}
